<template>
  <div class="output-message">
    <span v-if="message.status !== 'loading'" class="code">{{ message.data.input }}{{ message.data.error || message.data.output }}</span>
    <loading-dot v-else></loading-dot>
  </div>
</template>

<script>
  import LoadingDot from './LoadingDot'

  export default {
    components: {LoadingDot},
    props: ['message']
  }
</script>

<style lang="stylus" scoped>
</style>